import { createContext } from 'react'
import { AccessContextType } from '@src/utils/types'

export const AccessContext = createContext<AccessContextType>({})
